import { useMemo } from 'react';

interface Props {
  value?: string | null;
  diameter?: number;
}
/**
 * Ethereum Hex String
 */
export default function EthereumHexString({ value, diameter = 12 }: Props) {
  const regexp = useMemo(() => {
    const numElements = Math.round(diameter / 2);
    return new RegExp(`^(\\w{${numElements}}).*(\\w{${numElements}})$`);
  }, [diameter]);
  return <>{value?.replace(regexp, '$1...$2')}</>;
}
